module.exports = __webpack_public_path__ + "img/spiderman.bd3b2710.png";